import httpClient from '../httpClient';


const getOccationalBanner =  () => httpClient.get('/MainPage/TopBanner/Get').then(
  (data) => data
)
  .catch(()=>{
    //
  })
const setOccationalBanner =  (params) => httpClient.post('/MainPage/TopBanner/Post', {
  webImgPath:params.webImgPath,
  mobileImgPath:params.mobileImgPath,
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
const putOccationalBanner = (params,id) => httpClient.put(`/MainPage/TopBanner/Put/${id}`, params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })


const  deleteOccationalBanner= (id) => httpClient.delete(`/MainPage/TopBanner/Delete/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

export {
  getOccationalBanner,
  setOccationalBanner,
  putOccationalBanner,
  deleteOccationalBanner
  // getUser,
  // createUser
}
